<div class="benefit-image-wrapper" (click)="redirestToBenefitDetailsScreen()">
  <div class="benefit-background"></div>
  <img [src]="benefitData.imageUrl"/>
  <div class="dimming-name-container">
    <span>{{ benefitData.name }}</span>
  </div>
</div>